import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { IconEdit } from "@tabler/icons-react";
import { LangConstant } from "const";
import { Pagination } from "components";
import { DatetimeUtils } from "utils";

const Datatable = ({ positions, selectedPositions, pagination, onChangePage, onSelectPosition, onClickEdit }) => {
  const { t: getLabel } = useTranslation();
  const selectedPositionIds = selectedPositions.map(position => position.positionId);

  return (
    <Fragment>
      <div className="table-responsive" style={{ marginTop: 16, marginBottom: 16 }}>
        <table className="table table-vcenter" style={{ whiteSpace: "nowrap", tableLayout: "fixed", minWidth: 650 }}>
          <thead>
            <tr>
              <th style={{ width: "10%" }}></th>
              <th style={{ width: "20%", fontWeight: "bold" }}>{getLabel("TXT_POSITION_NAME")}</th>
              <th style={{ width: "20%", fontWeight: "bold" }}>{getLabel("TXT_UNIT_NAME")}</th>
              <th style={{ width: "20%", fontWeight: "bold" }}>{getLabel("TXT_DEPARTMENT_NAME")}</th>
              <th style={{ width: "20%", fontWeight: "bold" }}>{getLabel("TXT_CREATED_AT")}</th>
              <th style={{ width: "10%" }}></th>
            </tr>
          </thead>
          <tbody>
            {positions.length > 0 ? (
              positions.map((position, index) => (
                <tr key={index}>
                  <td>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={selectedPositionIds.includes(position.positionId)}
                      onChange={() => onSelectPosition(position)}
                    />
                  </td>
                  <td
                    style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                    title={position.positionName}
                  >
                    {position.positionName}
                  </td>
                  <td
                    style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                    title={position.unitName}
                  >
                    {position.unitName}
                  </td>
                  <td
                    style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                    title={position.departmentName}
                  >
                    {position.departmentName || getLabel(LangConstant.TXT_NOT_FOUND)}
                  </td>
                  <td>{DatetimeUtils.convertMillisecondsToDatetime(position.created)}</td>
                  <td>
                    <button className="btn btn-icon btn-ghost-primary btn-sm" onClick={() => onClickEdit(position)}>
                      <IconEdit size={16} />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="text-center">
                  <small>
                    <i>{getLabel(LangConstant.TXT_NOT_FOUND)}</i>
                  </small>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {pagination.total > 1 && (
        <Pagination currentPage={pagination.current} totalPages={pagination.total} onPageChange={onChangePage} />
      )}
    </Fragment>
  );
};

export default Datatable;
